module.exports = __webpack_public_path__ + "static/favicon.b4df2748.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.ico
// module id = 288
// module chunks = 168707334958949